import { Meta } from '@storybook/addon-docs/blocks';

<Meta title="Overview/Usage" />

# Generic Drupal Web Components

Inspired by
[@generic-components/components](https://www.npmjs.com/package/@generic-components/components)
this project aims to create a library of generic web components that are
accessible, framework agnostic, possible to style, and easy to use with data
provided by [Drupal](https://www.drupal.org).

## Usage

### Via NPM

Components can be installed via NPM (View
[example on Codesandbox](https://codesandbox.io/s/gdwc-import-joowy)):

```bash
npm i @gdwc/components
```

And imported in your code via ES imports:

```js
import '@gdwc/components/menu';
```

### Via CDN

Alternatively you can load the components from a CDN and drop them in your HTML
file as a script tag. (View
[example on Codepen](https://codepen.io/brianperry/pen/QWdyONQ))

```html
<script type="module">
  import gdwcComponents from 'https://cdn.skypack.dev/@gdwc/components';
</script>
```

```html
<gdwc-menu
  branding="Menu Heading"
  baseUrl="https://dev-ds-demo.pantheonsite.io"
  menuId="main"
></gdwc-menu>
```

Note: using the baseUrl and menuId attributes with the gdwc-custom element
requires a Drupal site with the
[Decoupled Menus module](https://www.drupal.org/project/decoupled_menus)
enabled.
